import fetch from 'utils/fetch'
export function insertLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/insertLab`,
    method: 'post',
    data
  })
}
// 确定邀请某人
export function doInviteUser (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/doInviteUsers`,
    method: 'post',
    data
  })
}
// 获取已有的(审核通过的)labList
export function getListLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getListLab`,
    method: 'post',
    data
  })
}
// 获取已有的(审核通过的)labList 总数
export function countListLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/countListLab`,
    method: 'post',
    data
  })
}
export function getLabById (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getLabInfo`,
    method: 'post',
    data
  })
}
export function updateLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/updateLab`,
    method: 'post',
    data
  })
}
export function getUserListByLabIdIsNull (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/getUserListByLabIdIsNull`,
    method: 'post',
    data
  })
}
export function removeUserAndRoleFromLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/deleteLabUserRole`,
    method: 'post',
    data
  })
}
// 获取无lab人员
export function getLabUserList (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getLabUserList`,
    method: 'post',
    data
  })
}
export function getLabUserListCount (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getLabUserListCount`,
    method: 'post',
    data
  })
}
// 获取lab可修改权限
export function getLabRoleCv (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getLabRoleCv`,
    method: 'post',
    data
  })
}
// 修改lab权限
export function modifyLabUserRole (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/modifyLabUserRole`,
    method: 'post',
    data
  })
}
// 退出实验室
export function doQuitLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/doQuitLab`,
    method: 'post',
    data
  })
}
// 修改meta LAB 名
export function modifyLabNameInSample (data) {
  return fetch({
    url: `/project/experiment/modifyLabNameInSample`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/lab.js